
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-shipping",
      function () {
        return require("private-next-pages/free-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-shipping"])
      });
    }
  